import React, { Component } from 'react'
import PropTypes from 'prop-types'
import * as notificationActionCreators from '../../../redux/notifications'
import * as userManagerActionsCreators from '../../../redux/css-admin/userManager/operations'
import * as modalActionsCreators from '../../../redux/modal'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import {
  ModalHeader,
  ModalBody,
  ModalFooter,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  FormGroup,
  Label,
  Input,
  Button,
} from 'reactstrap'
import ErrorBoundary from 'components/ErrorBoundary'
import Loading from 'components/Loading/Loading'
import SchoolLookUp from 'components/SchoolLookUp'
import Select from 'components/Select'
import CustomCheckBox from 'components/CustomCheckBox'
import { jobTitles } from '../../../lib/meta'

export class EditProductUserModal extends Component {
  static propTypes = {
    archetypes: PropTypes.array,
    closeModal: PropTypes.func.isRequired,
    isLoading: PropTypes.bool,
    isSaving: PropTypes.bool.isRequired,
    productUser: PropTypes.object.isRequired,
    saveAndHandleProductUser: PropTypes.func.isRequired,
  }
  static Tabs = {
    Personal: 1,
    Organization: 4,
  }
  constructor(props) {
    super(props)
    this.state = {
      activeTab: EditProductUserModal.Tabs.Personal,
      isDirty: false,
      isSaving: false,
      editUser: null,
      siteData: {
        city: '',
        country: '',
        region: '',
        netsuiteCustomerId: '',
        organizationName: '',
      },
    }
  }

  componentDidMount() {
    const editUser = { ...this.props.productUser }
    const { archetypes = [] } = editUser
    const archetypesMap = new Map()
    archetypes.forEach(archetype => archetypesMap.set(archetype.id, archetype))
    editUser.archetypes = archetypesMap
    const siteData = {
      country: editUser.country,
      region: editUser.region,
      city: editUser.city,
      netsuiteCustomerId: editUser.netSuiteCustomerId,
      organizationName: editUser.siteName,
    }
    this.setState({ editUser, siteData })
  }
  setCurrentTab = tab => {
    if (this.state.activeTab !== tab) this.setState({ activeTab: tab })
  }

  handleChange = e => {
    const fieldName = e.target.name
    const fieldValue = e.target.value
    const editUser = { ...this.state.editUser }
    editUser[fieldName] = fieldValue
    this.setState({ isDirty: true, editUser })
  }

  handleSchoolSelection = siteData => {
    this.setState({ siteData, isDirty: true })
  }

  handleArchetypeSelection = (archetype, hasArchetype) => {
    const editUser = { ...this.state.editUser }
    if (hasArchetype) {
      editUser.archetypes.delete(archetype.id)
    } else {
      editUser.archetypes.set(archetype.id, archetype)
    }
    this.setState({ isDirty: true, editUser })
  }

  saveUser = async () => {
    const { editUser, siteData } = this.state
    const newUser = { ...editUser }
    newUser.netSuiteCustomerId = siteData.netsuiteCustomerId
    newUser.country = siteData.country
    newUser.region = siteData.region
    newUser.city = siteData.city
    newUser.siteName =
      siteData.netsuiteCustomerId === 0 || siteData.netsuiteCustomerId === null
        ? siteData.siteName
        : siteData.organizationName
    newUser.archetypes = Array.from(newUser.archetypes.keys())
    if (siteData.siteId === 'UNLISTED') newUser.siteId = null
    await this.props.saveAndHandleProductUser(newUser)
    this.props.closeModal()
  }

  isNotNullOrEmpty = str => {
    return str && str.length > 0
  }

  isValid = () => {
    const { editUser, isDirty } = this.state
    const { firstName, lastName, title, archetypes } = editUser
    return (
      this.isNotNullOrEmpty(firstName) &&
      this.isNotNullOrEmpty(lastName) &&
      this.isNotNullOrEmpty(title) &&
      archetypes.size > 0 &&
      isDirty
    )
  }
  render = () => {
    const { isSaving, isLoading, closeModal } = this.props
    const { editUser, siteData, activeTab } = this.state
    if (!editUser) return null
    const {
      firstName,
      lastName,
      email,
      title,
      isSSO,
      mobilePhoneNumber,
      contactPhoneNumber,
    } = editUser

    return (
      <ErrorBoundary>
        <Loading isLoading={isLoading} />
        <Loading isLoading={isSaving} message="Saving..." />
        <ModalHeader toggle={closeModal}>Edit User</ModalHeader>
        <ModalBody>
          <Nav justified tabs>
            <NavItem>
              <NavLink
                active={activeTab === EditProductUserModal.Tabs.Personal}
                onClick={() =>
                  this.setCurrentTab(EditProductUserModal.Tabs.Personal)
                }
              >
                Personal
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                active={activeTab === EditProductUserModal.Tabs.Organization}
                onClick={() =>
                  this.setCurrentTab(EditProductUserModal.Tabs.Organization)
                }
              >
                Organization
              </NavLink>
            </NavItem>
          </Nav>
          <br />
          <TabContent activeTab={activeTab}>
            <TabPane tabId={EditProductUserModal.Tabs.Personal}>
              <p className="float-right">* Required Field</p>
              <FormGroup>
                <Label for="firstName">First Name</Label>
                <Input
                  id="firstName"
                  name="firstName"
                  onChange={this.handleChange}
                  readOnly={isSSO}
                  required
                  value={firstName || ''}
                />
                {!this.isNotNullOrEmpty(firstName) && (
                  <span className="text-danger">first name is required </span>
                )}
              </FormGroup>
              <FormGroup>
                <Label for="lastName">Last Name</Label>
                <Input
                  id="lastName"
                  name="lastName"
                  onChange={this.handleChange}
                  readOnly={isSSO}
                  required
                  value={lastName || ''}
                />
                {!this.isNotNullOrEmpty(lastName) && (
                  <span className="text-danger"> last name is required </span>
                )}
              </FormGroup>
              <FormGroup>
                <Label for="displayName">Email</Label>
                <Input
                  disabled={true}
                  id="email"
                  name="email"
                  onChange={this.handleChange}
                  value={email || ''}
                />
              </FormGroup>
              <FormGroup>
                <Select
                  data={jobTitles}
                  label="Job Title&nbsp;*"
                  name="title"
                  onChange={this.handleChange}
                  value={title || ''}
                />
                {!this.isNotNullOrEmpty(title) && (
                  <span className="text-danger"> job title is required </span>
                )}
              </FormGroup>
              <FormGroup>
                <Label>Archetype</Label>
                {this.props.archetypes &&
                  this.props.archetypes.map(archetype => {
                    const hasArchetype = editUser.archetypes.has(archetype.id)
                    return (
                      <CustomCheckBox
                        checked={hasArchetype}
                        key={'edit-user-profile-archetype'}
                        name={archetype.archetypeName}
                        text={archetype.description}
                        onChange={() =>
                          this.handleArchetypeSelection(archetype, hasArchetype)
                        }
                      />
                    )
                  })}
                {editUser.archetypes.size <= 0 && (
                  <span className="text-danger">
                    An archetype must be selected
                  </span>
                )}
              </FormGroup>
              <FormGroup>
                <Label for="contactPhoneNumber">
                  Office Phone&nbsp;<small>(optional)</small>
                </Label>
                <Input
                  id="contactPhoneNumber"
                  name="contactPhoneNumber"
                  onChange={this.handleChange}
                  value={contactPhoneNumber || ''}
                />
              </FormGroup>
              <FormGroup>
                <Label for="mobilePhoneNumber">
                  Mobile Phone&nbsp;<small>(optional)</small>
                </Label>
                <Input
                  id="mobilePhoneNumber"
                  name="mobilePhoneNumber"
                  onChange={this.handleChange}
                  value={mobilePhoneNumber || ''}
                />
              </FormGroup>
            </TabPane>
          </TabContent>
          <TabContent activeTab={activeTab}>
            <TabPane tabId={EditProductUserModal.Tabs.Organization}>
              <SchoolLookUp
                onSelection={this.handleSchoolSelection}
                siteData={siteData}
                fireOnLoad={false}
              />
            </TabPane>
          </TabContent>
        </ModalBody>
        <ModalFooter>
          <Button color="link" onClick={this.props.closeModal}>
            Cancel
          </Button>
          <Button
            color="success"
            disabled={!this.isValid() || this.props.isSaving}
            onClick={this.saveUser}
          >
            Save
          </Button>
        </ModalFooter>
      </ErrorBoundary>
    )
  }
}

const mapStateToProps = ({ userManager }) => ({
  archetypes: userManager.archetypes.data,
  productUser: userManager.productUser,
  isSaving: userManager.isSaving,
})

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      ...userManagerActionsCreators,
      ...notificationActionCreators,
      ...modalActionsCreators,
    },
    dispatch,
  )
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(EditProductUserModal)



// WEBPACK FOOTER //
// ./src/containers/css-admin/users/EditProductUserModal.js